import { Component, EventEmitter, effect, Output } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';

// Services

// Types
import { MatButtonModule } from '@angular/material/button';
import {
  RimsFormBuilderService,
  RimsFormDescriptor,
  RimsFormDescriptorField,
} from '@app/pages/incidents/details-page/rims/rims-edit-panel/rims-form/rims-form-builder/rims-form-builder.service';
import { blockInvalidNumericSymbol } from '@app/shared/numeric-validations';
import { isRimsSetItemField } from '@app/utils/rims/rims.utils';

export type FormData = {
  name: string;
  placeholder?: string;
  value: string;
  fieldType: 'text' | 'number' | 'checkbox';
};

@Component({
  standalone: true,
  selector: 'app-rims-form',
  imports: [
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  templateUrl: './rims-form.component.html',
  styleUrl: './rims-form.component.scss',
})
export class RimsFormComponent {
  protected form: RimsFormDescriptor | null;
  protected blockInvalidNumericSymbol = blockInvalidNumericSymbol;
  protected isRimsSetItemField = isRimsSetItemField;

  @Output() requestFormChange = new EventEmitter<RimsFormDescriptorField>();

  constructor(private readonly formBuilderService: RimsFormBuilderService) {
    this.form = null;
    effect(() => {
      this.form = this.formBuilderService.activeForm();
    });
  }

  protected onClearField(event: Event, fieldName: string): void {
    event.stopPropagation();

    if (!this.form) {
      return;
    }

    const control = this.form.formGroup.get(fieldName);
    if (control) {
      control.setValue(null);
      control.markAsTouched();
      control.markAsDirty();
    }
  }

  // For Objects and Collections
  protected requestForm(field: RimsFormDescriptorField): void {
    this.requestFormChange.emit(field);
  }
}
